var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCricketSmallIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27789 2.44116C2.77557 2.28969 3.20547 2.15885 3.79388 1.58618L4.11067 1.26938C3.67571 0.783566 3.06054 0.5 2.38995 0.5C0.754139 0.5 -0.365501 2.15809 0.250719 3.6793L0.446991 3.483C1.17039 2.77823 1.7588 2.59915 2.27789 2.44116Z",
    fill: "#78829D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.986178 4.03263L0.669434 4.34937C1.10142 4.83144 1.71422 5.11875 2.39013 5.11875C4.02597 5.11875 5.14561 3.46064 4.52939 1.93945L4.33309 2.13575C3.60971 2.84055 3.02133 3.0196 2.50221 3.17762C2.00449 3.32906 1.57463 3.45987 0.986178 4.03263Z",
    fill: "#78829D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93444 7.36666L6.39017 6.82229L8.30673 4.90594L7.76605 4.36523L6.66232 4.37283L0.256836 10.7783C0.452441 12.1925 1.56425 13.3043 2.97847 13.4999L9.38395 7.09446L9.39155 5.99073L8.85105 5.45023L6.93444 7.36666Z",
    fill: "#78829D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67969 2.98828L11.8306 0.837337L12.9191 1.92583L10.7682 4.07677L9.67969 2.98828Z",
    fill: "#78829D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57764 4.08984L9.13547 3.53201L10.224 4.6205L9.66613 5.17833L8.57764 4.08984Z",
    fill: "#78829D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCricketSmallIcon);
export default ForwardRef;